export default function SelectInput({ label, name, placeholder, optional, value, options, onChange, validationError, canModifyDetails }) {
    let selectInputClassNames = 'esc-ii-border esc-ii-py-4 esc-ii-px-4 esc-ii-rounded esc-ii-border-secondary esc-ii-font-montserrat esc-ii-text-xs lg:esc-ii-text-sm focus:esc-ii-outline-none focus:esc-ii-ring-primary focus:esc-ii-border-primary';
    if (!value) {
        selectInputClassNames += ' esc-font-light';
    }

    return (
        <div className="esc-ii-flex esc-ii-flex-col">
            <label htmlFor={`#` + name} className="esc-ii-mb-3">
                <span className="esc-ii-uppercase esc-ii-font-bold esc-ii-font-montserrat esc-ii-text-[10px] lg:esc-ii-text-xs">
                    {label}
                </span>
                {optional && <span className="esc-ii-ml-2 esc-ii-font-montserrat esc-ii-text-[10px] lg:esc-ii-text-xs">(Optional)</span>}
            </label>
            {canModifyDetails ? (
                <select
                    name={name}
                    isp_ignore
                    className={selectInputClassNames}
                    onChange={onChange}
                    placeholder={placeholder}
                    value={value}
                >
                    <optgroup>
                    {
                        options.map((option, index) => (
                            <option value={option.value} selected={index === 0} disabled={index === 0}>{option.label}</option>
                        ))
                    }
                    </optgroup>
                </select>
            ) : (
                <p className="esc-ii-font-montserrat esc-ii-text-base lg:esc-ii-text-lg">{value}</p>
            )}
            {validationError && (
                <p className="esc-ii-font-montserrat esc-ii-text-[10px] lg:esc-ii-text-xs esc-ii-text-red-600 esc-ii-mt-2">{validationError}</p>
            )}
        </div>
    );
}
